import { render, staticRenderFns } from "./PaymentMethodList.vue?vue&type=template&id=323d1538&scoped=true&"
import script from "./PaymentMethodList.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodList.vue?vue&type=style&index=0&id=323d1538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d1538",
  null
  
)

export default component.exports